var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUserImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#028383;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 10,
    r: 9.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,20C4.5,20,0,15.5,0,10C0,4.5,4.5,0,10,0s10,4.5,10,10C20,15.5,15.5,20,10,20z M10,1.5 c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5C18.5,5.3,14.7,1.5,10,1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,9.2h-3.2V6c0-0.4-0.3-0.8-0.8-0.8S9.2,5.6,9.2,6v3.2H6c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h3.2V14 c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-3.2H14c0.4,0,0.8-0.3,0.8-0.8S14.4,9.2,14,9.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserImage);
export default __webpack_public_path__ + "static/media/addUserImage.4770306ad5b3d89bbae05383dcbd4280.svg";
export { ForwardRef as ReactComponent };